<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
_/                                                                                                                    _/
_/      子画面定義：ダイアログ定義                                                               _/
_/                                                                                                                    _/
_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->

<template>
  <BaseModal :show="isShow">
    <form>
      <div class="popup" style="width: 700px">
        <div class="popup-head">パスワード変更</div>
        <div class="popup-body blue">
          <!--
          ****  メッセージ表示領域 **** -->
          <p
            class="errMsg title-ico ico-warning alignleft mb-5"
            v-show="errors != ''"
          >
            <ErrorMessage isModalError :errors="errors"></ErrorMessage>
          </p>
          <p>{{ descriptText }}</p>
          <!--                          -->
          <div>
            <div class="para">
              <div class="frm-row">
                <span class="frm-label w-150px">
                  <strong>ログインID</strong>
                </span>
                <input
                  disabled
                  type="text"
                  class="frm-text frm-size-l"
                  v-model="passwordChangeForm.loginId"
                />
              </div>
              <div class="frm-row">
                <span class="frm-label w-150px">
                  <strong>利用者名</strong>
                </span>
                <input
                  type="text"
                  disabled
                  class="frm-text frm-size-l"
                  v-model="passwordChangeForm.userName"
                />
              </div>

              <div class="frm-row">
                <span class="frm-label w-150px">
                  <strong>パスワード変更</strong>
                </span>
                <label class="frm-checkbox" v-show="passwordChangeDisplayFlag">
                  <input
                    type="checkbox"
                    v-model="passwordChangeForm.passwordChangeFlag"
                    :disabled="passwordChangeDisabledFlag"
                  />
                  <span
                    class="checkbox-item"
                    :tabindex="passwordChangeDisabledFlag ? -1 : 0"
                    @keydown.space.stop.prevent="
                      passwordChangeForm.passwordChangeFlag =
                        !passwordChangeForm.passwordChangeFlag
                    "
                  ></span>
                  <span class="checkbox-text">パスワードを変更する</span>
                </label>
              </div>
              <div
                class="frm-row"
                style="padding-left: 40px"
                v-show="oldPasswordDisplayFlag"
              >
                <span class="frm-label w-150px">
                  <strong>古いパスワード </strong>
                </span>
                <PasswordInput
                  v-model="passwordChangeForm.oldPassword"
                  inputClass="frm-password"
                  :hasError="isOldPasswordError"
                  autocomplete="new-password"
                />
              </div>
              <p
                class="errMsg"
                style="margin-left: 194px"
                v-show="oldPasswordDisplayFlag && isOldPasswordError"
              >
                <ErrorMessageCase
                  :errors="errors_oldPassword"
                ></ErrorMessageCase>
              </p>

              <div
                class="frm-row"
                :class="!isPasswordError ? 'mt-5' : ''"
                style="padding-left: 40px"
              >
                <span class="frm-label w-150px">
                  <strong>新しいパスワード </strong>
                </span>
                <PasswordInput
                  v-model="passwordChangeForm.password"
                  inputClass="frm-password"
                  :hasError="isPasswordError"
                  :disabled="passwordDisabledFlag"
                  :tabindex="passwordDisabledFlag ? -1 : 0"
                />
              </div>
              <p
                class="errMsg ml-200px"
                v-show="isPasswordError"
                style="margin-left: 194px"
              >
                <ErrorMessageCase :errors="errors_password"></ErrorMessageCase>
              </p>

              <div
                class="frm-row"
                :class="!isPassword2Error ? 'mt-5' : ''"
                style="padding-left: 40px"
              >
                <span class="frm-label">
                  <strong>新しいパスワード(確認) </strong>
                </span>
                <PasswordInput
                  v-model="passwordChangeForm.password2"
                  inputClass="frm-password"
                  :hasError="isPassword2Error"
                  :disabled="passwordDisabledFlag"
                  :tabindex="passwordDisabledFlag ? -1 : 0"
                />
              </div>
              <p
                class="errMsg alignleft ml-100px"
                v-show="isPassword2Error"
                style="margin-left: 194px"
              >
                <ErrorMessageCase :errors="errors_password2"></ErrorMessageCase>
              </p>

              <div class="frm-row mt-5" v-show="passwordChangeDisplayFlag">
                <span class="frm-label w-150px">
                  <strong>パスワード変更要求 </strong>
                </span>
                <label class="frm-checkbox">
                  <input
                    type="checkbox"
                    v-model="passwordChangeForm.passwordChangeRequestFlag"
                  />
                  <span
                    class="checkbox-item"
                    tabindex="0"
                    @keydown.space.stop.prevent="
                      passwordChangeForm.passwordChangeRequestFlag =
                        !passwordChangeForm.passwordChangeRequestFlag
                    "
                  ></span>
                  <span class="checkbox-text"
                    >次回ログイン時にパスワードの変更を要求する</span
                  >
                </label>
              </div>
            </div>
          </div>
          <br />
          <div class="frm-btn-row footer-btn">
            <div class="frm-item grow center">
              <button
                tabindex="0"
                class="frm-btn strong large"
                @click.prevent="passwordChangeConfirm"
              >
                確定
              </button>
              <button
                ref="cancelBtn"
                class="frm-btn large"
                @click.prevent="passwordChangeCancel"
                tabindex="0"
              >
                キャンセル
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </BaseModal>
</template>

<script setup>
// #region import
import {
  ref,
  defineProps,
  reactive,
  computed,
  defineEmits,
  onMounted,
  watchEffect,
  watch,
  nextTick,
} from "vue";

import { useFocusTrap } from "@vueuse/integrations/useFocusTrap";
import { API_PasswordChange } from "@/api/Modules/DC05/STDSDC05C04";
import Common from "@/util/common.js";
import _ from "lodash";
import ErrorMessage from "@/components/ErrorMessage.vue";
import ErrorMessageCase from "@/components/ErrorMessageCase.vue";
import Validation from "@/util/validation.js";
import PasswordInput from "@/components/PasswordInput.vue";
import BaseModal from "@/components/Base/BaseModal.vue";
const refModal = ref();
const { activate, deactivate } = useFocusTrap(refModal);
// #endregion

// #region 共通
const props = defineProps({
  isShow: {
    type: Boolean,
    required: true,
    default: false,
  },
  parentPageId: {
    type: String,
    default: "",
  },
  loginId: {
    type: String,
    default: "",
  },
  initialLoginId: {
    type: String,
    default: "",
  },
  userName: {
    type: String,
    default: "",
  },
  userKeyName: {
    type: String,
    default: "",
  },
  userAuthorityType: {
    type: Number,
    default: 1,
  },
  passwordChangeRequestFlag: {
    type: Boolean,
    default: false,
  },
});

let currentLoginId = $cookies.get("currentLoginId");

const cancelBtn = ref(null);

const emit = defineEmits(["close", "getList", "detailChangeConfirm"]);

// **********************************************
// 初期フォカス
// **********************************************
watch(
  () => props.isShow,
  (newVal) => {
    if (newVal) {
      currentLoginId = $cookies.get("currentLoginId");
      nextTick(() => {
        activate();
        cancelBtn.value.focus();
        if (
          props.parentPageId === "STDSDC05C02" &&
          props.loginId !== currentLoginId
        ) {
          passwordChangeForm.passwordChangeFlag = false;
        }
      });
    } else {
      deactivate();
    }
  }
);

const close = () => {
  clearErrors();
  resetForm();
  emit("close");
};

// **********************************************
//　パスワード変更Form
// **********************************************
const passwordChangeForm = reactive({
  loginId: "",
  userName: "",
  passwordChangeFlag: true,
  passwordChangeRequestFlag: false,
  oldPasswordChangeRequestFlag: false,
  oldPassword: null,
  newPassword: "",
  password: "",
  password2: "",
  userKeyName: "",
  userAuthorityType: 1,
});

// **********************************************
// 画面最上部テキスト表示領域
// **********************************************
const descriptText = computed(() => {
  let text = "";
  if (
    props.parentPageId === "STDSDC05C02" &&
    props.loginId === currentLoginId
  ) {
    text = "パスワードの変更を行います。";
  } else if (
    props.parentPageId === "STDSDC05C02" &&
    props.loginId !== currentLoginId
  ) {
    text = "パスワードの変更、パスワードの変更要求を行います。";
  } else {
    text =
      "ログインIDを変更すると、別の利用者として扱われるため、パスワードを変更する必要があります。";
  }
  return text;
});

// **********************************************
// 「パスワードを変更する」チェック表示フラグ
// **********************************************
const passwordChangeDisplayFlag = computed(() => {
  return props.initialLoginId !== currentLoginId;
});

// **********************************************
// 「パスワードを変更する」チェック非活性フラグ
// **********************************************
const passwordChangeDisabledFlag = computed(() => {
  return props.parentPageId === "STDSDC05C03";
});

// **********************************************
// 古いパスワード表示フラグ
// **********************************************
const oldPasswordDisplayFlag = computed(() => {
  return props.initialLoginId === currentLoginId;
});

// **********************************************
// 新しいパスワードと新しいパスワード(確認)非活性フラグ
// **********************************************
const passwordDisabledFlag = computed(() => {
  return (
    props.initialLoginId !== currentLoginId &&
    props.parentPageId === "STDSDC05C02" &&
    !passwordChangeForm.passwordChangeFlag
  );
});

onMounted(() => {});

watchEffect(() => {
  passwordChangeForm.loginId = props.loginId;
  passwordChangeForm.userName = props.userName;
  passwordChangeForm.userKeyName = props.userKeyName;
  passwordChangeForm.userAuthorityType = props.userAuthorityType;
  passwordChangeForm.passwordChangeRequestFlag =
    props.passwordChangeRequestFlag;
  passwordChangeForm.oldPasswordChangeRequestFlag =
    props.passwordChangeRequestFlag;
});

// watch([() => props.loginId, () => props.userName], (newVal) => {
//   console.log(newVal);
//   passwordChangeForm.loginId = newVal[0];
//   passwordChangeForm.userName = newVal[1];
// });
// #endregion

// #region パスワード変更
// STDSDC05C03からパスワード変更した後、STDSDC05C03に戻ります
const detailChangeConfirm = () => {
  const passwordData = {
    password: passwordChangeForm.password,
    passwordChangeRequestFlag: passwordChangeForm.passwordChangeRequestFlag,
    oldPassword: passwordChangeForm.oldPassword,
  };
  emit("detailChangeConfirm", passwordData);
};

// **********************************************
// パスワード変更Dialog「確定」ボタン押下処理
// **********************************************
const passwordChangeConfirm = () => {
  if (validateForm()) {
    if (props.parentPageId === "STDSDC05C02") {
      passwordChangeForm.newPassword = passwordChangeForm.password;
      API_PasswordChange(passwordChangeForm).then(async (response) => {
        if (response.result == "0000") {
          emit("getList");
          close();
        } else {
          if (response.errorCD === "MTCL1126") {
            const msg = Common.createError(
              "MTCL1126",
              Common.getMessage("MTCL1126", ["編集"])
            );
            errors.value.push(msg);
          } else {
            // エラー表示
            const msg = response.errorName
              ? Common.createError(
                  response.errorCD,
                  Common.getMessage(response.errorCD, [response.errorName[0]])
                )
              : Common.createError(
                  response.errorCD,
                  Common.getMessage(response.errorCD, [])
                );
            errors.value.push(msg);
          }
        }
      });
    } else if (props.parentPageId === "STDSDC05C03") {
      detailChangeConfirm();
    }
  }
};

// **********************************************
// パスワード変更Dialog「キャンセル」ボタン押下処理
// **********************************************
const passwordChangeCancel = () => {
  close();
};

// **********************************************
// パスワード変更Form初期化処理
// **********************************************
const resetForm = () => {
  // passwordChangeForm.passwordChangeFlag = true;
  // passwordChangeForm.passwordChangeRequestFlag = false;
  passwordChangeForm.oldPassword = "";
  passwordChangeForm.password = "";
  passwordChangeForm.password2 = "";
};
// #endregion

// #region バリデーション
const errors = ref([]);
const errors_oldPassword = ref([]);
const errors_password = ref([]);
const errors_password2 = ref([]);

const isPasswordError = computed(() => {
  return errors_password.value.length > 0;
});

const isPassword2Error = computed(() => {
  return errors_password2.value.length > 0;
});

const isOldPasswordError = computed(() => {
  return errors_oldPassword.value.length > 0;
});

const addErrors = (errorMsg) => {
  errors.value = [];
  errors.value.push(errorMsg);
};

const validateForm = () => {
  clearErrors();

  // パスワード変更、パスワード変更要求いずれか一方、または双方チェックONであること。
  if (
    passwordChangeDisplayFlag.value &&
    !passwordChangeForm.passwordChangeFlag
  ) {
    return true;
  }

  if (oldPasswordDisplayFlag.value && !passwordChangeForm.oldPassword) {
    errors_oldPassword.value.push(
      Common.createError(
        "MTCL1001",
        Common.getMessage("MTCL1001", ["古いパスワード"])
      )
    );
  }
  // 新しいパスワード
  // 必須チェック
  if (!passwordChangeForm.password) {
    errors_password.value.push(
      Common.createError(
        "MTCL1001",
        Common.getMessage("MTCL1001", ["新しいパスワード"])
      )
    );
  } else if (
    !Validation.checkCharType(
      passwordChangeForm.password,
      "alphanumeric-symbol"
    )
  ) {
    // 半角チェック
    errors_password.value.push(
      Common.createError(
        "MTCL1003",
        Common.getMessage("MTCL1003", ["新しいパスワード"])
      )
    );
  } else if (
    !Validation.isPassword(
      passwordChangeForm.loginId,
      passwordChangeForm.password
    )
  ) {
    // パスワード規範化チェック
    errors_password.value.push(
      Common.createError("MTCL1038", Common.getMessage("MTCL1038"))
    );
  } else if (passwordChangeForm.password === passwordChangeForm.oldPassword) {
    // 新しいパスワードと古いパスワード不一致性チェック
    errors_password.value.push(
      Common.createError("MTCL1092", Common.getMessage("MTCL1092"))
    );
  }
  // 新しいパスワード(確認)
  // 必須チェック
  if (!passwordChangeForm.password2) {
    errors_password2.value.push(
      Common.createError(
        "MTCL1001",
        Common.getMessage("MTCL1001", ["新しいパスワード(確認)"])
      )
    );
  } else if (
    !Validation.checkCharType(
      passwordChangeForm.password2,
      "alphanumeric-symbol"
    )
  ) {
    // 半角チェック
    errors_password2.value.push(
      Common.createError(
        "MTCL1003",
        Common.getMessage("MTCL1003", ["新しいパスワード(確認)"])
      )
    );
  } else if (passwordChangeForm.password2 !== passwordChangeForm.password) {
    // 新しいパスワードと新しいパスワード(確認)一致性チェック
    errors_password2.value.push(
      Common.createError("MTCL1088", Common.getMessage("MTCL1088"))
    );
  }

  if (
    isPasswordError.value ||
    isPassword2Error.value ||
    isOldPasswordError.value
  ) {
    topErrorscheck();
    return false;
  }
  return true;
};

// topエラー表示制御
const topErrorscheck = () => {
  if (!errors.value || errors.value.length == 0) {
    errors.value.push(
      Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
    );
  }
};

const clearErrors = () => {
  errors.value = [];
  errors_oldPassword.value = [];
  errors_password.value = [];
  errors_password2.value = [];
};
// #endregion

defineExpose({
  addErrors,
});
</script>
　
